import { Buffer as NodeBuffer } from 'buffer';
if (typeof global !== 'undefined') {
    global.Buffer = global.Buffer || NodeBuffer;
}
else if (typeof window !== 'undefined') {
    window.Buffer = window.Buffer || NodeBuffer;
    window.global = window.global || window;
}
else {
    self.Buffer = self.Buffer || NodeBuffer;
    self.global = self.global || self;
}
import { Network, OnRampAsset, OnRampProvider, OnRampPurchaseStatus, WalletScheme, WalletType, } from '@usecapsule/user-management-client';
export { Network, OnRampAsset, OnRampProvider, OnRampPurchaseStatus };
export const is2FAEnabled = false;
export var Environment;
(function (Environment) {
    // Internal Environments
    Environment["DEV"] = "DEV";
    Environment["SANDBOX"] = "SANDBOX";
    Environment["BETA"] = "BETA";
    Environment["PROD"] = "PROD";
    // Customer-Facing Environments
    // NOTE: these resolve to the corresponding internal environments for convenience
    Environment["DEVELOPMENT"] = "BETA";
    Environment["PRODUCTION"] = "PROD";
})(Environment || (Environment = {}));
export var OAuthMethod;
(function (OAuthMethod) {
    OAuthMethod["GOOGLE"] = "GOOGLE";
    OAuthMethod["TWITTER"] = "TWITTER";
    OAuthMethod["APPLE"] = "APPLE";
    OAuthMethod["DISCORD"] = "DISCORD";
    OAuthMethod["FACEBOOK"] = "FACEBOOK";
    OAuthMethod["FARCASTER"] = "FARCASTER";
})(OAuthMethod || (OAuthMethod = {}));
export var EnabledFlow;
(function (EnabledFlow) {
    EnabledFlow["BUY"] = "BUY";
    EnabledFlow["RECEIVE"] = "RECEIVE";
    EnabledFlow["WITHDRAW"] = "WITHDRAW";
})(EnabledFlow || (EnabledFlow = {}));
export var OnRampMethod;
(function (OnRampMethod) {
    OnRampMethod["ACH"] = "ACH";
    OnRampMethod["DEBIT"] = "Debit";
    OnRampMethod["CREDIT"] = "Credit";
    OnRampMethod["APPLE_PAY"] = "Apple Pay";
})(OnRampMethod || (OnRampMethod = {}));
export const WalletSchemeTypeMap = {
    [WalletScheme.DKLS]: {
        [WalletType.EVM]: true,
        [WalletType.COSMOS]: true,
    },
    [WalletScheme.CGGMP]: {
        [WalletType.EVM]: true,
        [WalletType.COSMOS]: true,
    },
    [WalletScheme.ED25519]: {
        [WalletType.SOLANA]: true,
    },
};
export function getPortalDomain(env, isE2E) {
    if (isE2E) {
        return `localhost`;
    }
    switch (env) {
        case Environment.DEV:
            return 'localhost';
        case Environment.SANDBOX:
            return 'app.sandbox.usecapsule.com';
        case Environment.BETA:
            return 'app.beta.usecapsule.com';
        case Environment.PROD:
            return 'app.usecapsule.com';
        default:
            throw new Error(`env: ${env} not supported`);
    }
}
export function getPortalBaseURL({ env, isE2E }, useLocalIp, isForWasm) {
    if (isE2E) {
        if (isForWasm) {
            return `https://app.sandbox.usecapsule.com`;
        }
        return `http://localhost:3003`;
    }
    const domain = getPortalDomain(env);
    if (env === Environment.DEV) {
        if (useLocalIp) {
            return `http://127.0.0.1:3003`;
        }
        return `http://${domain}:3003`;
    }
    return `https://${domain}`;
}
export const EXTERNAL_WALLET_CHANGE_EVENT = 'capsuleExternalWalletChange';
export const CURRENT_WALLET_IDS_CHANGE_EVENT = 'capsuleCurrentWalletIdsChange';
export function toAssetInfoArray(data) {
    const result = [];
    Object.keys(data).forEach(walletType => {
        const networks = data[walletType];
        Object.keys(networks).forEach(network => {
            const assets = networks[network];
            Object.keys(assets).forEach(asset => {
                const providerInfo = assets[asset];
                result.push([walletType, network, asset, providerInfo]);
            });
        });
    });
    return result;
}
export function getOnRampNetworks(data, { walletType, allowed } = {}) {
    return [
        ...new Set(toAssetInfoArray(data)
            .filter(([type, network]) => (!walletType || type === walletType) && (!allowed || allowed.includes(network)))
            .map(([_, network]) => network)),
    ];
}
export function getOnRampAssets(data, { walletType, network, allowed, } = {}) {
    return [
        ...new Set(toAssetInfoArray(data)
            .filter(([t, n, a]) => (!walletType || t === walletType) &&
            (!network || n === network) &&
            (!Array.isArray(allowed) || allowed.includes(a)))
            .map(([, , asset]) => asset)),
    ];
}
